import React from 'react';

interface SupportIconProps {
  size?: number;
  strokeWidth?: number;
  className?: string;
}

const SupportIcon: React.FC<SupportIconProps> = ({
  size = 24,
  strokeWidth = 1.8,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Z" />
    <path d="M21 11h-3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-5Z" />
    <path d="M3 11a9 9 0 0 1 18 0" />
    <path d="M21 16v2a4 4 0 0 1-4 4h-5" />
  </svg>
);

export default SupportIcon;
